import { useRef, useState, setIsShown} from "react";
import {firestore} from "../firebase";
import {addDoc, getDocs, collection} from "@firebase/firestore"
import { Button, Container } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';

export default function Login() {
    const [isShown, setIsShown] = useState(false);

    const USER = useRef();
    const PASS = useRef();
    const CONFPASS = useRef();
    var err = "";

    const user_collection = collection(firestore, "users");

    const handleRegister = async(e) => {
        e.preventDefault();

        var canAdd = true;

        // password + confirm match
        if (PASS.current.value !== CONFPASS.current.value) {
            console.log("confirm doesnt match");
            canAdd = false;
            err = "Passwords dont match.";
        }

        if (canAdd === true) {
            console.log("checking db");
            let snapshot = await getDocs(user_collection);
            snapshot.forEach(docSnap => {
                var userdata = docSnap.data();
                if (userdata.name === USER.current.value) {
                    canAdd = false;
                }
            });
            err = "Username is not available.";
        }

        if (canAdd === true) {
            console.log("adding");
            await addDoc(collection(firestore, "users"), {
                name: USER.current.value,
                pass: PASS.current.value
            });

            window.username = USER.current.value;
            setIsShown(current => !current);
        }

        try {
            document.getElementById("err").innerText = err;
        } catch (e) {
            console.log("cannot print error");
        }
    }
    return (
        <>
            <div>
                {isShown && (
                    <Container style={{ marginTop: "1em" }}>
                        <Tab.Container id="left-tabs-example" defaultActiveKey="login">
                            <Row>
                                <Col sm={3}>
                                    <Nav variant="pills" className="flex-column">
                                        <Nav.Item>
                                            <Nav.Link eventKey="login">Login</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="register">Register</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="contact">Contact</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col sm={9}>
                                    <Tab.Content>
                                        <Tab.Pane eventKey="login">
                                            <p>Logged in as {window.username}</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="register">
                                            <p>Logged in as {window.username}</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="contact">
                                            <ContactContent />
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </Container>
                )}
            </div>
            <div>
                {!isShown && (
                    <Container style={{marginTop: "1em"}}>
                        <Tab.Container id="left-tabs-example" defaultActiveKey="login">
                            <Row>
                                <Col sm={3}>
                                <Nav variant="pills" className="flex-column">
                                    <Nav.Item>
                                        <Nav.Link eventKey="login">Login</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="register">Register</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey="contact">Contact</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                                </Col>
                                <Col sm={9}>
                                <Tab.Content>
                                    <Tab.Pane eventKey="login">
                                        <LoginContent />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="register">
                                        <Container>
                                            <br></br>
                                            <h1>Register</h1>
                                            <br></br>
                                            <Row id="row">
                                                <form onSubmit={handleRegister}>
                                                    <Col sm={12}>
                                                        <p>Create username</p>
                                                        <input type="text" ref={USER}/>
                                                        <p style={{marginTop: "1em"}}>Create password</p> 
                                                        <input type="password" ref={PASS}/>
                                                        <p style={{marginTop: "1em"}}>Confirm password</p> 
                                                        <input type="password" ref={CONFPASS}/>
                                                    </Col>
                                                    <Button type="submit" style={{marginTop: "2em", marginBottom: "2em"}}>Submit</Button>
                                                    <p id="err"></p>
                                                </form>
                                            </Row>
                                        </Container>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="contact">
                                        <ContactContent />
                                    </Tab.Pane>
                                </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </Container>
                )}
            </div>
        </>
    );
}

function LoginContent() {
    const USER = useRef();
    const PASS = useRef();

    const handleLogin = async(e) => {
      e.preventDefault();
      console.log(USER.current.value);
      console.log(PASS.current.value);
    }

    return (
        <>
            <Container>
                <br></br>
                <h1>Login</h1>
                <br></br>
                <Row>
                    <form onSubmit={handleLogin}>
                        <Col sm={12}>
                            <p>Username</p>
                            <input type="text" ref={USER}/>
                            <p style={{marginTop: "1em"}}>Password</p> 
                            <input type="password" ref={PASS}/>
                        </Col>
                        <Button type="submit" style={{marginTop: "2em"}}>Submit</Button>
                    </form>
                </Row>
            </Container>
        </>
        
    );
}

function ContactContent() {
    return (
        <>
            <br></br>
            <h1>Contact</h1>
        </>
        
    );
}